import * as Yup from "yup";

const passwordConfirmationValidationSchema = Yup.string()
  .oneOf([Yup.ref("password")], "Passwords must match")
  .required("Confirm Password is required");

export default passwordConfirmationValidationSchema;
